import { getGameSize } from '../../Config/Levels';
import Core, { GameOrientation } from '../../Core/Core';
import { gameConfig } from '../../index';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { Popup } from '../../Managers/Popups';
import { createPixiText } from '../../Utils/Utils';
import { ButtonColors } from '../Shared/Buttons/NineSliceButton';
import { TextButton } from '../Shared/Buttons/TextButton';
import { LifeDisplay } from '../Shared/LifeDisplay';
import { CharacterPopup } from './CharacterPopup';

export class DoubleCheckPopup extends CharacterPopup {
    constructor(txt: string) {
        const bgWidth = gameConfig.game_width * 0.9;
        const bgHeight =
            Core.orientation === GameOrientation.PORTRAIT
                ? gameConfig.game_height * 0.6
                : gameConfig.game_height * 0.5;
        super(bgWidth, bgHeight, 'character/character-lose', 'GiveUp', Popup.MODAL);

        let elems = [];

        const heart = new LifeDisplay(-1, true);
        heart.x = bgWidth * 0.5;
        heart.y = Core.orientation === GameOrientation.PORTRAIT ? bgHeight * 0.48 : bgHeight * 0.42;
        heart.scale.set(0.8);

        if (Core.orientation === GameOrientation.PORTRAIT) {
            const txtDisplay = createPixiText(
                txt,
                new PIXI.Rectangle(bgWidth * 0.5, bgHeight * 0.2, bgWidth * 0.6, bgHeight * 0.3),
                'Baloo',
                35,
                30,
                0x006eba // what
            );
            txtDisplay.anchor.set(0.5);
            txtDisplay.y = bgHeight * 0.32;
            txtDisplay.text = txt;
            elems.push(txtDisplay);
        }

        const yesButton = new TextButton({
            width: bgWidth * 0.5,
            height: bgHeight * 0.3,
            btnText: Core.local.getText('playon'),
        });
        yesButton.x = bgWidth / 2;
        yesButton.y =
            Core.orientation === GameOrientation.PORTRAIT ? bgHeight * 0.68 : bgHeight * 0.65;
        yesButton.once('trigger', this.handleNo.bind(this));
        yesButton.interactive = true;
        yesButton.buttonMode = true;

        const noButton = new TextButton({
            width: bgWidth * 0.4,
            height: bgHeight * 0.3,
            btnText: Core.local.getText('quit'),
            color: ButtonColors.RED,
        });
        noButton.x = bgWidth / 2;
        noButton.y =
            Core.orientation === GameOrientation.PORTRAIT ? bgHeight * 0.82 : bgHeight * 0.82;
        noButton.once('trigger', this.handleYes.bind(this));
        noButton.interactive = true;
        noButton.buttonMode = true;

        this.x = gameConfig.game_width * 0.5 + getGameSize().xOffset - bgWidth / 2;
        this.y = getGameSize().gameHeight + 500;

        elems = [...elems, yesButton, noButton, heart];
        // @ts-ignore
        this.addChild(...elems);
    }

    private handleYes(e: PIXI.interaction.InteractionEvent) {
        HudEmitter.instance.emit(HudActions.MODAL, ...[true, HudActions.QUIT_GAME]);
        this.removeAllListeners();
    }

    private handleNo(e: PIXI.interaction.InteractionEvent) {
        HudEmitter.instance.emit(HudActions.MODAL, ...[false]);
        this.removeAllListeners();
    }
}
